import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import getUser from './services/user-info.js'
import store from './store';
import mitt from 'mitt';
import './registerServiceWorker';
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts';
import HighchartsMore from "highcharts/highcharts-more";
import SolidGauge from 'highcharts/modules/solid-gauge';
import '../src/components/universal_styles.vue';
import VueHighlightJS from 'vue3-highlightjs';
import '../src/assets/highlight-js-theme.css';
import Vue3ColorPicker from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import { ImagesControl } from './services/ImagesControl.js';
import Vue3TouchEvents from "vue3-touch-events";
import Draggable, { DraggablePlugin, DraggableDirective } from '@braks/revue-draggable';
import VueDragscroll from 'vue-dragscroll';

fetch('/config.json').then(res => res.json()).then(async function (config) {
  console.log("config fetch completed successfully..")
  // alert(config.api);
  const emitter = mitt();

  HighchartsMore(Highcharts);
  SolidGauge(Highcharts);
  const app = createApp(App);
  app.config.globalProperties.emitter = emitter;
  app.provide('isarchive', config.isarchive);
  app.provide('apiPath', config.api);
  app.provide('build', config.build);
  app.provide('cloudflareLink', config.cfLink);
  if (window.location.host.startsWith('localhost')) {
    app.provide('pspdfkitlkey', config.pspdfkitlkeyl);
  } else {
    app.provide('pspdfkitlkey', config.pspdfkitlkey);
  }
  app.provide('imagesControl', new ImagesControl());
  app.use(store);
  app.use(router);
  app.use(HighchartsVue);
  app.use(VueHighlightJS);
  app.use(Vue3TouchEvents);
  app.use(DraggablePlugin);
  app.use(VueDragscroll);
  app.use(Vue3ColorPicker);
  console.log("All components added in main..")
  console.log("Attempting to set user..")
  app.provide('user', (localStorage.getItem('bOpus_user') !== null ? JSON.parse(localStorage.getItem('bOpus_user')) : null));
  app.mount('#app');

});